var map = {
	"./assets/ai/sections/images/mcp_logo_240_2.webp": "cb03",
	"./assets/blog/adobe-commerce-vs-magento.webp": "640c",
	"./assets/blog/adobe-commerce-vs-magento/adobe-commerce-vs-magento.webp": "138b",
	"./assets/blog/adobe-commerce-vs-magento/blog-adobe-vs-magento-img-2.webp": "867b",
	"./assets/blog/adobe-commerce-vs-magento/blog-adobe-vs-magento-img.webp": "c8d1",
	"./assets/blog/buissonniere-e-commerce-success-story.webp": "4f5d",
	"./assets/blog/buissonniere-e-commerce-success-story/buissonniere-e-commerce-success-story-img-1.webp": "bfdd",
	"./assets/blog/cant-find.webp": "2393",
	"./assets/blog/chat-gpt-integration.webp": "9e67",
	"./assets/blog/code-review.webp": "2700",
	"./assets/blog/development-during-recession/development-during-recession-top.webp": "f16e",
	"./assets/blog/driving-sales-home-for-the-holidays.webp": "feb8",
	"./assets/blog/driving-sales-home-for-the-holidays/driving-sales-home-for-the-holidays-img-1.webp": "aaac",
	"./assets/blog/driving-sales-home-for-the-holidays/driving-sales-home-for-the-holidays-img-2.webp": "8e82",
	"./assets/blog/driving-sales-home-for-the-holidays/driving-sales-home-for-the-holidays-img-3.webp": "ba03",
	"./assets/blog/epr/epr-article-top-img.webp": "bd99",
	"./assets/blog/epr/epr-article-top-img@2x.webp": "e317",
	"./assets/blog/epr/epr-article-top-img_medium.webp": "0475",
	"./assets/blog/epr/epr-article-top-img_medium@2x.webp": "60d2",
	"./assets/blog/epr/epr-article-top-img_small.webp": "d975",
	"./assets/blog/epr/epr-article-top-img_small@2x.webp": "5924",
	"./assets/blog/erp.webp": "5328",
	"./assets/blog/handling-massive-product-db-in-magento.webp": "fa94",
	"./assets/blog/home-delivery-date.webp": "7190",
	"./assets/blog/home-delivery-date/home-delivery-date-top-img.webp": "fee4",
	"./assets/blog/home-delivery-date/home-delivery-date-top-img@2x.webp": "b6c1",
	"./assets/blog/home-delivery-date/home-delivery-date-top-img_medium.webp": "4d67",
	"./assets/blog/home-delivery-date/home-delivery-date-top-img_medium@2x.webp": "22c2",
	"./assets/blog/home-delivery-date/home-delivery-date-top-img_small.webp": "8a78",
	"./assets/blog/home-delivery-date/home-delivery-date-top-img_small@2x.webp": "7f64",
	"./assets/blog/hopways.webp": "8f52",
	"./assets/blog/hopways/hopways-02.webp": "0a4e",
	"./assets/blog/hopways/hopways-03.webp": "000d",
	"./assets/blog/images/epr-price.webp": "46d5",
	"./assets/blog/images/epr-price@2x.webp": "b276",
	"./assets/blog/images/epr-price_medium.webp": "913a",
	"./assets/blog/images/epr-price_medium@2x.webp": "d459",
	"./assets/blog/images/epr-price_small.webp": "c4ca",
	"./assets/blog/images/epr-price_small@2x.webp": "6bed",
	"./assets/blog/images/epr.webp": "2809",
	"./assets/blog/images/epr@2x.webp": "5514",
	"./assets/blog/images/epr_medium.webp": "9d47",
	"./assets/blog/images/epr_medium@2x.webp": "7332",
	"./assets/blog/images/epr_small.webp": "ca02",
	"./assets/blog/images/epr_small@2x.webp": "1a48",
	"./assets/blog/images/home-delivery.webp": "b2eb",
	"./assets/blog/images/home-delivery@2x.webp": "c8c0",
	"./assets/blog/images/home-delivery_medium.webp": "6342",
	"./assets/blog/images/home-delivery_medium@2x.webp": "752c",
	"./assets/blog/images/home-delivery_small.webp": "f708",
	"./assets/blog/images/home-delivery_small@2x.webp": "cb9a",
	"./assets/blog/keep-afloat-by-outsourcing-web-development-during-recession.webp": "c589",
	"./assets/blog/magento-code-review.webp": "fac0",
	"./assets/blog/magento-code-review/code-analysis.webp": "772d2",
	"./assets/blog/magento-code-review/code-reviewer.webp": "b4ed",
	"./assets/blog/magento-code-review/magento-code-review.webp": "8b01",
	"./assets/blog/magento-code-review/programmer-and-coding-concept.webp": "b096",
	"./assets/blog/magento-code-review/screen-img-01.webp": "b012",
	"./assets/blog/magento-code-review/screen-img-02.webp": "fdee",
	"./assets/blog/magento-vs-woocommerce-showdown.webp": "b470",
	"./assets/blog/openai-account-banned-for-policy-violations.webp": "62b5",
	"./assets/blog/outsourcing-company-vs-recruiting-agency.webp": "1038",
	"./assets/blog/outsourcing-recruiting/article-image-1.webp": "9bad",
	"./assets/blog/outsourcing-recruiting/article-image-2.webp": "0e0e",
	"./assets/blog/outsourcing-recruiting/article-image-3.webp": "aa73",
	"./assets/blog/outsourcing-recruiting/outsourcing-company-vs-recruiting-agency.webp": "44fc",
	"./assets/blog/razzo.webp": "7d92",
	"./assets/blog/security-audit.webp": "3af3",
	"./assets/blog/shopify-limitations-for-e-commerce.webp": "7cd8",
	"./assets/blog/shopify-limitations-for-e-commerce/shopify-limitations-for-e-commerce-img-1.webp": "36cc",
	"./assets/blog/shopify-limitations-for-e-commerce/shopify-limitations-for-e-commerce-img-2.webp": "5eb5",
	"./assets/blog/shopify-limitations-for-e-commerce/shopify-limitations-for-e-commerce-img-3.webp": "2359",
	"./assets/blog/shopify-limitations-for-e-commerce/shopify-limitations-for-e-commerce-img-4.webp": "57e1",
	"./assets/blog/vape-shop-custom-website.webp": "3cf1",
	"./assets/blog/vape-shop-custom-website/vape-shop-custom-website-img-1.webp": "4ae5",
	"./assets/blog/vape-shop-custom-website/vape-shop-custom-website-img-2.webp": "240e",
	"./assets/blog/vape-shop-custom-website/vape-shop-custom-website-img-3.webp": "a246",
	"./assets/blog/vape-shop-custom-website/vape-shop-custom-website-img-4.webp": "b2bd",
	"./assets/blog/vape-shop-custom-website/vape-shop-custom-website-img-5.webp": "5a35",
	"./assets/blog/why-ai-agents-break-in-production.webp": "c2f8",
	"./assets/cant-find/bg-cant-find.webp": "ef82",
	"./assets/cant-find/bg-cant-find@2x.webp": "0bc4",
	"./assets/cant-find/bg-cant-find_medium.webp": "2e21",
	"./assets/cant-find/bg-cant-find_medium@2x.webp": "837d",
	"./assets/cant-find/bg-cant-find_small.webp": "d395",
	"./assets/cant-find/bg-cant-find_small@2x.webp": "1305",
	"./assets/cant-find/customer.webp": "2bbb",
	"./assets/cant-find/customer@2x.webp": "550a",
	"./assets/cant-find/customer_medium.webp": "203f",
	"./assets/cant-find/customer_medium@2x.webp": "184b",
	"./assets/cant-find/customer_small.webp": "0ffe",
	"./assets/cant-find/customer_small@2x.webp": "2d53",
	"./assets/cant-find/innovations.webp": "7058",
	"./assets/cant-find/innovations@2x.webp": "7db4",
	"./assets/cant-find/innovations_medium.webp": "4a6b",
	"./assets/cant-find/innovations_medium@2x.webp": "13a5",
	"./assets/cant-find/innovations_small.webp": "55a0",
	"./assets/cant-find/innovations_small@2x.webp": "333e",
	"./assets/cant-find/process.webp": "7df1",
	"./assets/cant-find/process@2x.webp": "0a8f",
	"./assets/cant-find/process_medium.webp": "438c",
	"./assets/cant-find/process_medium@2x.webp": "48de",
	"./assets/cant-find/process_small.webp": "aad1",
	"./assets/cant-find/process_small@2x.webp": "5ec0",
	"./assets/design-portfolio/images/design-preview.webp": "755f",
	"./assets/design-portfolio/images/games/games-1.webp": "7ef2",
	"./assets/design-portfolio/images/games/games-10.webp": "d274",
	"./assets/design-portfolio/images/games/games-11.webp": "2cdf",
	"./assets/design-portfolio/images/games/games-12.webp": "1026",
	"./assets/design-portfolio/images/games/games-13.webp": "9cb2",
	"./assets/design-portfolio/images/games/games-14.webp": "ac8e",
	"./assets/design-portfolio/images/games/games-15.webp": "c9ce",
	"./assets/design-portfolio/images/games/games-16.webp": "8637",
	"./assets/design-portfolio/images/games/games-17.webp": "392e",
	"./assets/design-portfolio/images/games/games-18.webp": "53d6",
	"./assets/design-portfolio/images/games/games-19.webp": "d89f",
	"./assets/design-portfolio/images/games/games-2.webp": "c5c4",
	"./assets/design-portfolio/images/games/games-20.webp": "4da6",
	"./assets/design-portfolio/images/games/games-21.webp": "da1b",
	"./assets/design-portfolio/images/games/games-22.webp": "41ca",
	"./assets/design-portfolio/images/games/games-23.webp": "65ac",
	"./assets/design-portfolio/images/games/games-24.webp": "5fe5",
	"./assets/design-portfolio/images/games/games-3.webp": "d3b3",
	"./assets/design-portfolio/images/games/games-4.webp": "c08d",
	"./assets/design-portfolio/images/games/games-5.webp": "43e4",
	"./assets/design-portfolio/images/games/games-6.webp": "9fc4",
	"./assets/design-portfolio/images/games/games-7.webp": "f5d9",
	"./assets/design-portfolio/images/games/games-8.webp": "c7d8",
	"./assets/design-portfolio/images/games/games-9.webp": "1ba2",
	"./assets/design-portfolio/images/gui/amx/amx-1.webp": "01dd",
	"./assets/design-portfolio/images/gui/amx/amx-10.webp": "f0c5",
	"./assets/design-portfolio/images/gui/amx/amx-11.webp": "5dad",
	"./assets/design-portfolio/images/gui/amx/amx-12.webp": "a854",
	"./assets/design-portfolio/images/gui/amx/amx-13.webp": "11e7",
	"./assets/design-portfolio/images/gui/amx/amx-14.webp": "fd03",
	"./assets/design-portfolio/images/gui/amx/amx-15.webp": "2e7c",
	"./assets/design-portfolio/images/gui/amx/amx-16.webp": "f98f",
	"./assets/design-portfolio/images/gui/amx/amx-17.webp": "9d8b",
	"./assets/design-portfolio/images/gui/amx/amx-18.webp": "ef6d",
	"./assets/design-portfolio/images/gui/amx/amx-19.webp": "a723",
	"./assets/design-portfolio/images/gui/amx/amx-2.webp": "b732",
	"./assets/design-portfolio/images/gui/amx/amx-20.webp": "ab27",
	"./assets/design-portfolio/images/gui/amx/amx-21.webp": "dff6",
	"./assets/design-portfolio/images/gui/amx/amx-22.webp": "8c22",
	"./assets/design-portfolio/images/gui/amx/amx-3.webp": "e25e",
	"./assets/design-portfolio/images/gui/amx/amx-4.webp": "7a2b",
	"./assets/design-portfolio/images/gui/amx/amx-5.webp": "dc84d",
	"./assets/design-portfolio/images/gui/amx/amx-6.webp": "a5ab",
	"./assets/design-portfolio/images/gui/amx/amx-7.webp": "6f0f",
	"./assets/design-portfolio/images/gui/amx/amx-8.webp": "e272",
	"./assets/design-portfolio/images/gui/amx/amx-9.webp": "db38",
	"./assets/design-portfolio/images/gui/builder/builder-1.webp": "4cda",
	"./assets/design-portfolio/images/gui/builder/builder-10.webp": "5db5",
	"./assets/design-portfolio/images/gui/builder/builder-11.webp": "80ba",
	"./assets/design-portfolio/images/gui/builder/builder-12.webp": "62e9",
	"./assets/design-portfolio/images/gui/builder/builder-13.webp": "d8f2",
	"./assets/design-portfolio/images/gui/builder/builder-14.webp": "b1c0",
	"./assets/design-portfolio/images/gui/builder/builder-15.webp": "64b2",
	"./assets/design-portfolio/images/gui/builder/builder-16.webp": "eafc",
	"./assets/design-portfolio/images/gui/builder/builder-17.webp": "d5d8",
	"./assets/design-portfolio/images/gui/builder/builder-18.webp": "9d4f",
	"./assets/design-portfolio/images/gui/builder/builder-19.webp": "caed",
	"./assets/design-portfolio/images/gui/builder/builder-2.webp": "a972",
	"./assets/design-portfolio/images/gui/builder/builder-20.webp": "1f79",
	"./assets/design-portfolio/images/gui/builder/builder-21.webp": "a0b5",
	"./assets/design-portfolio/images/gui/builder/builder-22.webp": "6468",
	"./assets/design-portfolio/images/gui/builder/builder-23.webp": "8b4f",
	"./assets/design-portfolio/images/gui/builder/builder-24.webp": "8712",
	"./assets/design-portfolio/images/gui/builder/builder-25.webp": "ac4a",
	"./assets/design-portfolio/images/gui/builder/builder-26.webp": "54b3",
	"./assets/design-portfolio/images/gui/builder/builder-27.webp": "ea29",
	"./assets/design-portfolio/images/gui/builder/builder-28.webp": "e5c3",
	"./assets/design-portfolio/images/gui/builder/builder-29.webp": "40d6",
	"./assets/design-portfolio/images/gui/builder/builder-3.webp": "0283",
	"./assets/design-portfolio/images/gui/builder/builder-30.webp": "b430",
	"./assets/design-portfolio/images/gui/builder/builder-31.webp": "b8d1",
	"./assets/design-portfolio/images/gui/builder/builder-32.webp": "5cbd",
	"./assets/design-portfolio/images/gui/builder/builder-33.webp": "9fbf",
	"./assets/design-portfolio/images/gui/builder/builder-34.webp": "44a7",
	"./assets/design-portfolio/images/gui/builder/builder-35.webp": "5a52",
	"./assets/design-portfolio/images/gui/builder/builder-36.webp": "da15",
	"./assets/design-portfolio/images/gui/builder/builder-37.webp": "1018",
	"./assets/design-portfolio/images/gui/builder/builder-4.webp": "1d04",
	"./assets/design-portfolio/images/gui/builder/builder-5.webp": "5ac7",
	"./assets/design-portfolio/images/gui/builder/builder-6.webp": "93b9",
	"./assets/design-portfolio/images/gui/builder/builder-7.webp": "e156",
	"./assets/design-portfolio/images/gui/builder/builder-8.webp": "7a19",
	"./assets/design-portfolio/images/gui/builder/builder-9.webp": "6e2e",
	"./assets/design-portfolio/images/gui/cisco/cisco-1.webp": "42cf",
	"./assets/design-portfolio/images/gui/cisco/cisco-2.webp": "69fb",
	"./assets/design-portfolio/images/gui/cisco/cisco-3.webp": "cc35",
	"./assets/design-portfolio/images/gui/cisco/cisco-4.webp": "419a",
	"./assets/design-portfolio/images/gui/parliament/parliament-1.webp": "a1482",
	"./assets/design-portfolio/images/gui/parliament/parliament-2.webp": "35263",
	"./assets/design-portfolio/images/gui/parliament/parliament-3.webp": "693a",
	"./assets/design-portfolio/images/gui/parliament/parliament-4.webp": "a6e6",
	"./assets/design-portfolio/images/gui/parliament/parliament-5.webp": "e2a2",
	"./assets/design-portfolio/images/gui/parliament/parliament-6.webp": "c83a",
	"./assets/design-portfolio/images/gui/parliament/parliament-7.webp": "4dcb",
	"./assets/design-portfolio/images/gui/parliament/parliament-8.webp": "e84f",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-1.webp": "2238",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-10.webp": "aae1",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-11.webp": "92cc",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-12.webp": "219f",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-13.webp": "7e82",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-14.webp": "ea28",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-15.webp": "51c5",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-16.webp": "2195",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-17.webp": "3da9",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-18.webp": "5ec5",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-19.webp": "c7d3",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-2.webp": "b01d",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-20.webp": "2a0d",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-21.webp": "af30",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-22.webp": "4feb",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-23.webp": "f349",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-24.webp": "6215",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-25.webp": "04fb",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-26.webp": "5096",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-27.webp": "c759",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-28.webp": "0708",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-29.webp": "a95c",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-3.webp": "e054",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-4.webp": "0a8a",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-5.webp": "c46b",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-6.webp": "1ed7",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-7.webp": "0723",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-8.webp": "13ba",
	"./assets/design-portfolio/images/gui/sprinkle/sprinkle-9.webp": "2615",
	"./assets/design-portfolio/images/gui/tpc/tpc-1.webp": "dd2f",
	"./assets/design-portfolio/images/gui/tpc/tpc-10.webp": "87c3",
	"./assets/design-portfolio/images/gui/tpc/tpc-11.webp": "c664",
	"./assets/design-portfolio/images/gui/tpc/tpc-12.webp": "85f0",
	"./assets/design-portfolio/images/gui/tpc/tpc-13.webp": "c678",
	"./assets/design-portfolio/images/gui/tpc/tpc-14.webp": "814b",
	"./assets/design-portfolio/images/gui/tpc/tpc-15.webp": "6c2a",
	"./assets/design-portfolio/images/gui/tpc/tpc-16.webp": "4a65",
	"./assets/design-portfolio/images/gui/tpc/tpc-17.webp": "2b44",
	"./assets/design-portfolio/images/gui/tpc/tpc-18.webp": "f1bd",
	"./assets/design-portfolio/images/gui/tpc/tpc-19.webp": "de6f",
	"./assets/design-portfolio/images/gui/tpc/tpc-2.webp": "f8dc",
	"./assets/design-portfolio/images/gui/tpc/tpc-20.webp": "6545",
	"./assets/design-portfolio/images/gui/tpc/tpc-21.webp": "2096",
	"./assets/design-portfolio/images/gui/tpc/tpc-22.webp": "339f",
	"./assets/design-portfolio/images/gui/tpc/tpc-23.webp": "2104",
	"./assets/design-portfolio/images/gui/tpc/tpc-24.webp": "57df",
	"./assets/design-portfolio/images/gui/tpc/tpc-25.webp": "526a",
	"./assets/design-portfolio/images/gui/tpc/tpc-26.webp": "b492",
	"./assets/design-portfolio/images/gui/tpc/tpc-27.webp": "2200",
	"./assets/design-portfolio/images/gui/tpc/tpc-28.webp": "7e27",
	"./assets/design-portfolio/images/gui/tpc/tpc-29.webp": "620e",
	"./assets/design-portfolio/images/gui/tpc/tpc-3.webp": "a5ec",
	"./assets/design-portfolio/images/gui/tpc/tpc-30.webp": "f3d7",
	"./assets/design-portfolio/images/gui/tpc/tpc-31.webp": "bf73",
	"./assets/design-portfolio/images/gui/tpc/tpc-32.webp": "92ce",
	"./assets/design-portfolio/images/gui/tpc/tpc-33.webp": "8938",
	"./assets/design-portfolio/images/gui/tpc/tpc-34.webp": "3e35",
	"./assets/design-portfolio/images/gui/tpc/tpc-35.webp": "d70e",
	"./assets/design-portfolio/images/gui/tpc/tpc-36.webp": "2401",
	"./assets/design-portfolio/images/gui/tpc/tpc-37.webp": "0278",
	"./assets/design-portfolio/images/gui/tpc/tpc-38.webp": "a50f",
	"./assets/design-portfolio/images/gui/tpc/tpc-39.webp": "e81d",
	"./assets/design-portfolio/images/gui/tpc/tpc-4.webp": "88b6",
	"./assets/design-portfolio/images/gui/tpc/tpc-40.webp": "73ff",
	"./assets/design-portfolio/images/gui/tpc/tpc-41.webp": "e1a7",
	"./assets/design-portfolio/images/gui/tpc/tpc-42.webp": "e32c",
	"./assets/design-portfolio/images/gui/tpc/tpc-5.webp": "b2a3",
	"./assets/design-portfolio/images/gui/tpc/tpc-6.webp": "95dd",
	"./assets/design-portfolio/images/gui/tpc/tpc-7.webp": "a993",
	"./assets/design-portfolio/images/gui/tpc/tpc-8.webp": "183a",
	"./assets/design-portfolio/images/gui/tpc/tpc-9.webp": "0500",
	"./assets/design-portfolio/images/gui/vpn/vpn-1.webp": "253d",
	"./assets/design-portfolio/images/gui/vpn/vpn-2.webp": "d0c7",
	"./assets/design-portfolio/images/gui/vpn/vpn-3.webp": "34b2",
	"./assets/design-portfolio/images/gui/vpn/vpn-4.webp": "6c74",
	"./assets/design-portfolio/images/gui/vpn/vpn-5.webp": "f6fa",
	"./assets/design-portfolio/images/gui/vpn/vpn-6.webp": "0966",
	"./assets/design-portfolio/images/gui/vpn/vpn-7.webp": "7437",
	"./assets/design-portfolio/images/gui/vpn/vpn-8.webp": "bd43",
	"./assets/design-portfolio/images/logos/logo1mix-1.webp": "bd29",
	"./assets/design-portfolio/images/logos/logo2mix-1.webp": "716f",
	"./assets/design-portfolio/images/logos/logo3mix-1.webp": "7695",
	"./assets/design-portfolio/images/mobile/angel/angel-1.webp": "25ae",
	"./assets/design-portfolio/images/mobile/angel/angel-2.webp": "57cd",
	"./assets/design-portfolio/images/mobile/angel/angel-3.webp": "5828",
	"./assets/design-portfolio/images/mobile/chevron/chevron-1.webp": "bdff",
	"./assets/design-portfolio/images/mobile/chevron/chevron-2.webp": "7266",
	"./assets/design-portfolio/images/mobile/chevron/chevron-3.webp": "490f",
	"./assets/design-portfolio/images/mobile/chevron/chevron-4.webp": "69ba",
	"./assets/design-portfolio/images/mobile/goalbook/goalbook-1.webp": "9d3f",
	"./assets/design-portfolio/images/mobile/mdm-deploy/mdm-deploy-1.webp": "e607",
	"./assets/design-portfolio/images/mobile/mdm-deploy/mdm-deploy-2.webp": "a192",
	"./assets/design-portfolio/images/mobile/mdm-deploy/mdm-deploy-3.webp": "33a2",
	"./assets/design-portfolio/images/mobile/mdm-deploy/mdm-deploy-4.webp": "3e10",
	"./assets/design-portfolio/images/mobile/mdm-deploy/mdm-deploy-5.webp": "0758",
	"./assets/design-portfolio/images/mobile/mdm-deploy/mdm-deploy-6.webp": "2a77",
	"./assets/design-portfolio/images/mobile/menu-food/menu-food-1.webp": "6a99",
	"./assets/design-portfolio/images/mobile/menu-food/menu-food-2.webp": "717e",
	"./assets/design-portfolio/images/mobile/menu-food/menu-food-3.webp": "ad27",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-1.webp": "5fa0",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-10.webp": "1c88",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-11.webp": "daf5",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-12.webp": "6aad",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-13.webp": "ae43",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-2.webp": "feb0",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-3.webp": "991e",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-4.webp": "44e3",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-5.webp": "d070",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-6.webp": "c975",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-7.webp": "aee0",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-8.webp": "3b60",
	"./assets/design-portfolio/images/mobile/menu-hair/menu-hair-9.webp": "9ef1",
	"./assets/design-portfolio/images/mobile/menu-store/menu-store-1.webp": "f2e8",
	"./assets/design-portfolio/images/mobile/menu-store/menu-store-2.webp": "baaf",
	"./assets/design-portfolio/images/mobile/mix/mix-1.webp": "c958",
	"./assets/design-portfolio/images/mobile/mix/mix-2.webp": "804c",
	"./assets/design-portfolio/images/mobile/skypets/skypets-1.webp": "83d4",
	"./assets/design-portfolio/images/mobile/skypets/skypets-2.webp": "50f2",
	"./assets/design-portfolio/images/mobile/skypets/skypets-3.webp": "54fb",
	"./assets/design-portfolio/images/mobile/skypets/skypets-4.webp": "e75e",
	"./assets/design-portfolio/images/mobile/skypets/skypets-5.webp": "44ac",
	"./assets/design-portfolio/images/mobile/skypets/skypets-6.webp": "5b7c",
	"./assets/design-portfolio/images/mobile/waves/waves-1.webp": "772d",
	"./assets/design-portfolio/images/mobile/waves/waves-2.webp": "5b581",
	"./assets/design-portfolio/images/mobile/waves/waves-3.webp": "3848",
	"./assets/design-portfolio/images/mobile/waves/waves-4.webp": "785e",
	"./assets/design-portfolio/images/mobile/waves/waves-5.webp": "2f64",
	"./assets/design-portfolio/images/mobile/waves/waves-6.webp": "f8e2",
	"./assets/design-portfolio/images/mobile/waves/waves-7.webp": "6d73",
	"./assets/design-portfolio/images/mobile/waves/waves-8.webp": "6d09",
	"./assets/design-portfolio/images/mobile/waves/waves-9.webp": "3f3d",
	"./assets/design-portfolio/images/printed/incubator/incubator-1.webp": "3784",
	"./assets/design-portfolio/images/printed/incubator/incubator-2.webp": "cbcf",
	"./assets/design-portfolio/images/printed/incubator/incubator-3.webp": "b426",
	"./assets/design-portfolio/images/printed/lera-work/lera-work-1.webp": "cdbd",
	"./assets/design-portfolio/images/printed/lera-work/lera-work-2.webp": "7831",
	"./assets/design-portfolio/images/printed/lera-work/lera-work-3.webp": "0439",
	"./assets/design-portfolio/images/printed/tpc-brochures/tpc-brochures-1.webp": "de16",
	"./assets/design-portfolio/images/printed/tpc-brochures/tpc-brochures-2.webp": "04fe",
	"./assets/design-portfolio/images/printed/tpc-posters/tpc-posters-1.webp": "8b19",
	"./assets/design-portfolio/images/printed/tpc-posters/tpc-posters-2.webp": "3081",
	"./assets/design-portfolio/images/printed/tpc-printable-flyers/tpc-printable-flyers-1.webp": "2e95",
	"./assets/design-portfolio/images/printed/tpc-printable-flyers/tpc-printable-flyers-2.webp": "8f8b",
	"./assets/design-portfolio/images/printed/tpc-printable-flyers/tpc-printable-flyers-3.webp": "90d2",
	"./assets/design-portfolio/images/rocketship/rocketship-1.webp": "2ae1",
	"./assets/design-portfolio/images/rocketship/rocketship-2.webp": "9984",
	"./assets/design-portfolio/images/rocketship/rocketship-3.webp": "1e51",
	"./assets/design-portfolio/images/web/avnon/avnon-1.webp": "cf39",
	"./assets/design-portfolio/images/web/avnon/avnon-2.webp": "6218",
	"./assets/design-portfolio/images/web/avnon/avnon-3.webp": "e0cf",
	"./assets/design-portfolio/images/web/bsidd/bsidd-1.webp": "9bc8",
	"./assets/design-portfolio/images/web/bsidd/bsidd-2.webp": "d396",
	"./assets/design-portfolio/images/web/bsidd/bsidd-3.webp": "6d21",
	"./assets/design-portfolio/images/web/bsidd/bsidd-4.webp": "890e",
	"./assets/design-portfolio/images/web/bsidd/bsidd-5.webp": "d8e5",
	"./assets/design-portfolio/images/web/bsidd/bsidd-6.webp": "0120",
	"./assets/design-portfolio/images/web/classiccar/classiccar-1.webp": "d805",
	"./assets/design-portfolio/images/web/classiccar/classiccar-2.webp": "0575",
	"./assets/design-portfolio/images/web/cmg-labs/cmg-labs-1.webp": "e627",
	"./assets/design-portfolio/images/web/cmg-labs/cmg-labs-2.webp": "81a1",
	"./assets/design-portfolio/images/web/cmg-labs/cmg-labs-3.webp": "5566",
	"./assets/design-portfolio/images/web/cmg-labs/cmg-labs-4.webp": "13f5",
	"./assets/design-portfolio/images/web/dev-heroes/dev-heroes-1.webp": "5f30",
	"./assets/design-portfolio/images/web/dev-heroes/dev-heroes-2.webp": "6374d",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-1.webp": "3c52",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-10.webp": "868f",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-11.webp": "8585",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-12.webp": "b776",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-13.webp": "a3ac",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-14.webp": "fd03e",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-15.webp": "ff0f",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-16.webp": "b724",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-17.webp": "2a31",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-2.webp": "e9ed",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-3.webp": "ee0e",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-4.webp": "b795",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-5.webp": "0971",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-6.webp": "51e3",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-7.webp": "22b3",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-8.webp": "b3f7",
	"./assets/design-portfolio/images/web/html-evolution/html-evolution-9.webp": "b4b3",
	"./assets/design-portfolio/images/web/hys/hys-1.webp": "f519",
	"./assets/design-portfolio/images/web/hys/hys-2.webp": "479d",
	"./assets/design-portfolio/images/web/hys/hys-3.webp": "d86a",
	"./assets/design-portfolio/images/web/hys/hys-4.webp": "3618",
	"./assets/design-portfolio/images/web/hys/hys-5.webp": "db2a",
	"./assets/design-portfolio/images/web/hys/hys-6.webp": "c26e",
	"./assets/design-portfolio/images/web/hys/hys-7.webp": "e791",
	"./assets/design-portfolio/images/web/hys/hys-8.webp": "8008",
	"./assets/design-portfolio/images/web/hys/hys-9.webp": "e166",
	"./assets/design-portfolio/images/web/irrigation-control/irrigation-control-1.webp": "79f9",
	"./assets/design-portfolio/images/web/irrigation-control/irrigation-control-2.webp": "ea30",
	"./assets/design-portfolio/images/web/irrigation-control/irrigation-control-3.webp": "1494",
	"./assets/design-portfolio/images/web/irrigation-control/irrigation-control-4.webp": "eb81",
	"./assets/design-portfolio/images/web/linkd2/linkd2-1.webp": "5794",
	"./assets/design-portfolio/images/web/linkd2/linkd2-2.webp": "2395",
	"./assets/design-portfolio/images/web/linkd2/linkd2-3.webp": "d6a8",
	"./assets/design-portfolio/images/web/linkd2/linkd2-4.webp": "3079",
	"./assets/design-portfolio/images/web/lotery-rewards/lotery-rewards-1.webp": "3736",
	"./assets/design-portfolio/images/web/lotery-rewards/lotery-rewards-2.webp": "8d1c",
	"./assets/design-portfolio/images/web/lotery-rewards/lotery-rewards-3.webp": "4ddb",
	"./assets/design-portfolio/images/web/lotery-rewards/lotery-rewards-4.webp": "ee46",
	"./assets/design-portfolio/images/web/lotery-rewards/lotery-rewards-5.webp": "facd",
	"./assets/design-portfolio/images/web/price-click/price-click-1.webp": "ff3d",
	"./assets/design-portfolio/images/web/price-click/price-click-2.webp": "3dba",
	"./assets/design-portfolio/images/web/price-click/price-click-3.webp": "b636",
	"./assets/design-portfolio/images/web/price-click/price-click-4.webp": "4075",
	"./assets/design-portfolio/images/web/price-click/price-click-5.webp": "df21",
	"./assets/design-portfolio/images/web/rascrut/rascrut-1.webp": "e145",
	"./assets/design-portfolio/images/web/rascrut/rascrut-10.webp": "c075",
	"./assets/design-portfolio/images/web/rascrut/rascrut-11.webp": "1f31",
	"./assets/design-portfolio/images/web/rascrut/rascrut-12.webp": "dcb9",
	"./assets/design-portfolio/images/web/rascrut/rascrut-13.webp": "0252",
	"./assets/design-portfolio/images/web/rascrut/rascrut-2.webp": "f0a4",
	"./assets/design-portfolio/images/web/rascrut/rascrut-3.webp": "31b6",
	"./assets/design-portfolio/images/web/rascrut/rascrut-4.webp": "c27c",
	"./assets/design-portfolio/images/web/rascrut/rascrut-5.webp": "ac36",
	"./assets/design-portfolio/images/web/rascrut/rascrut-6.webp": "2906",
	"./assets/design-portfolio/images/web/rascrut/rascrut-7.webp": "f9d9",
	"./assets/design-portfolio/images/web/rascrut/rascrut-8.webp": "863d",
	"./assets/design-portfolio/images/web/rascrut/rascrut-9.webp": "15af",
	"./assets/design-portfolio/images/web/referto/referto-1.webp": "eda3",
	"./assets/design-portfolio/images/web/referto/referto-2.webp": "08f4",
	"./assets/design-portfolio/images/web/referto/referto-3.webp": "6e33",
	"./assets/design-portfolio/images/web/referto/referto-4.webp": "9e8f",
	"./assets/design-portfolio/images/web/referto/referto-5.webp": "7218",
	"./assets/design-portfolio/images/web/sage/sage-1.webp": "ae51",
	"./assets/design-portfolio/images/web/sage/sage-2.webp": "5d21",
	"./assets/design-portfolio/images/web/sage/sage-3.webp": "374d",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-1.webp": "f769",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-2.webp": "8a43",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-3.webp": "7616",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-4.webp": "cbdd",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-5.webp": "5c98",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-6.webp": "2ae4",
	"./assets/design-portfolio/images/web/shrewd-save/shrewd-save-7.webp": "f44e",
	"./assets/design-portfolio/images/web/tddg/tddg-1.webp": "b1ba",
	"./assets/design-portfolio/images/web/tddg/tddg-2.webp": "f951",
	"./assets/design-portfolio/images/web/tddg/tddg-3.webp": "d059",
	"./assets/design-portfolio/images/web/tddg/tddg-4.webp": "03c0",
	"./assets/design-portfolio/images/web/tddg/tddg-5.webp": "486e",
	"./assets/design-portfolio/images/web/tddg/tddg-6.webp": "18b2",
	"./assets/design-portfolio/images/web/tddg/tddg-7.webp": "3674",
	"./assets/design-portfolio/images/web/tddg/tddg-8.webp": "703c",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-1.webp": "7d95",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-10.webp": "f433",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-11.webp": "90d7",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-2.webp": "8ddd",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-3.webp": "4f35",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-4.webp": "c28e",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-5.webp": "c847",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-6.webp": "6793",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-7.webp": "f583",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-8.webp": "1504",
	"./assets/design-portfolio/images/web/tpc-web/tpc-web-9.webp": "4ef5",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-1.webp": "b16b",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-2.webp": "9110",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-3.webp": "76ce",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-4.webp": "5385",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-5.webp": "b238",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-6.webp": "6c35",
	"./assets/design-portfolio/images/web/traffic-junction/traffic-junction-7.webp": "5c2e",
	"./assets/footer-image.webp": "59c2",
	"./assets/footer-image@1.5x.webp": "a2b4",
	"./assets/footer-image@2x.webp": "c295",
	"./assets/home-hero-image_large.webp": "a109",
	"./assets/home-hero-image_medium.webp": "ba07",
	"./assets/home-hero-image_small.webp": "2745",
	"./assets/magento/find-out/bg-magento-find-out.webp": "d68b",
	"./assets/magento/find-out/bg-magento-find-out@2x.webp": "7731",
	"./assets/magento/find-out/bg-magento-find-out_medium.webp": "5364",
	"./assets/magento/find-out/bg-magento-find-out_medium@2x.webp": "516f",
	"./assets/magento/find-out/bg-magento-find-out_small.webp": "8ac1",
	"./assets/magento/find-out/bg-magento-find-out_small@2x.webp": "f38f",
	"./assets/magento/magento-banner.webp": "0531",
	"./assets/magento/magento-banner@2x.webp": "c52b",
	"./assets/magento/magento-banner_medium.webp": "f847",
	"./assets/magento/magento-banner_medium@2x.webp": "0141",
	"./assets/magento/magento-banner_small.webp": "85a5",
	"./assets/magento/magento-banner_small@2x.webp": "8417",
	"./assets/magento/magento-custom-development/magento-custom-development.webp": "7a79",
	"./assets/magento/magento-custom-development/magento-custom-development@2x.webp": "c8cb",
	"./assets/magento/magento-custom-development/magento-custom-development_medium.webp": "6553",
	"./assets/magento/magento-custom-development/magento-custom-development_medium@2x.webp": "a6d4",
	"./assets/magento/magento-custom-development/magento-custom-development_small.webp": "40a9",
	"./assets/magento/magento-custom-development/magento-custom-development_small@2x.webp": "d328",
	"./assets/magento/magento-migration/magento-migration.webp": "b78d",
	"./assets/magento/magento-migration/magento-migration@2x.webp": "0419",
	"./assets/magento/magento-migration/magento-migration_medium.webp": "e216",
	"./assets/magento/magento-migration/magento-migration_medium@2x.webp": "c4b0",
	"./assets/magento/magento-migration/magento-migration_small.webp": "6439",
	"./assets/magento/magento-migration/magento-migration_small@2x.webp": "f4a8",
	"./assets/magento/magento-modules-customization/magento-modules-customization.webp": "8867",
	"./assets/magento/magento-modules-customization/magento-modules-customization@2x.webp": "1cb9",
	"./assets/magento/magento-modules-customization/magento-modules-customization_medium.webp": "7c57",
	"./assets/magento/magento-modules-customization/magento-modules-customization_medium@2x.webp": "2b69",
	"./assets/magento/magento-modules-customization/magento-modules-customization_small.webp": "487f",
	"./assets/magento/magento-modules-customization/magento-modules-customization_small@2x.webp": "4671",
	"./assets/magento/magento-projects/aheadworks.webp": "4d06",
	"./assets/magento/magento-projects/buissonniere.webp": "f251",
	"./assets/magento/magento-projects/citrix_logo.webp": "d87e",
	"./assets/magento/magento-projects/citrixsynergy.webp": "d880",
	"./assets/magento/magento-projects/csc.webp": "52dc",
	"./assets/magento/magento-projects/csc_logo.webp": "922d",
	"./assets/magento/magento-projects/kukimi.webp": "1a81",
	"./assets/magento/magento-projects/kukimide.webp": "efd5",
	"./assets/magento/magento-projects/magento.webp": "15e9",
	"./assets/magento/magento-projects/magento_icons/adobe.webp": "3014",
	"./assets/magento/magento-projects/magento_icons/magento.webp": "689d",
	"./assets/magento/magento-projects/magento_icons/ms_azure.webp": "d54b",
	"./assets/magento/magento-projects/magento_icons/zabix.webp": "b54a",
	"./assets/magento/magento-projects/oscommers.webp": "7422",
	"./assets/magento/magento-projects/qg-main.webp": "3b8f",
	"./assets/magento/magento-projects/qg.webp": "987a",
	"./assets/magento/magento-projects/qg2.webp": "7ce2",
	"./assets/magento/magento-projects/transact.webp": "748d",
	"./assets/magento/magento-projects/york.webp": "bf8f",
	"./assets/magento/magento-security-services/magento-security-services.webp": "9f14",
	"./assets/magento/magento-security-services/magento-security-services@2x.webp": "e19f",
	"./assets/magento/magento-security-services/magento-security-services_medium.webp": "8c55",
	"./assets/magento/magento-security-services/magento-security-services_medium@2x.webp": "09b1",
	"./assets/magento/magento-security-services/magento-security-services_small.webp": "4a9e",
	"./assets/magento/magento-security-services/magento-security-services_small@2x.webp": "c1b1",
	"./assets/magento/magento-services-integration/magento-services-integration.webp": "0218",
	"./assets/magento/magento-services-integration/magento-services-integration@2x.webp": "42cd",
	"./assets/magento/magento-services-integration/magento-services-integration_medium.webp": "fb06",
	"./assets/magento/magento-services-integration/magento-services-integration_medium@2x.webp": "1cbf",
	"./assets/magento/magento-services-integration/magento-services-integration_small.webp": "e4e8",
	"./assets/magento/magento-services-integration/magento-services-integration_small@2x.webp": "8e05",
	"./assets/magento/magento-setup-tuning/magento-setup-tuning.webp": "d277",
	"./assets/magento/magento-setup-tuning/magento-setup-tuning@2x.webp": "8b12",
	"./assets/magento/magento-setup-tuning/magento-setup-tuning_medium.webp": "3f93",
	"./assets/magento/magento-setup-tuning/magento-setup-tuning_medium@2x.webp": "1c7f",
	"./assets/magento/magento-setup-tuning/magento-setup-tuning_small.webp": "1cb2",
	"./assets/magento/magento-setup-tuning/magento-setup-tuning_small@2x.webp": "fa07",
	"./assets/magento/magento-support-security/magento-support-security.webp": "1f41",
	"./assets/magento/magento-support-security/magento-support-security@2x.webp": "b476",
	"./assets/magento/magento-support-security/magento-support-security_medium.webp": "c562",
	"./assets/magento/magento-support-security/magento-support-security_medium@2x.webp": "5f8e",
	"./assets/magento/magento-support-security/magento-support-security_small.webp": "3a8f",
	"./assets/magento/magento-support-security/magento-support-security_small@2x.webp": "c0d2",
	"./assets/magento/magento-version-switching/magento-version-switching.webp": "1033",
	"./assets/magento/magento-version-switching/magento-version-switching@2x.webp": "95ac",
	"./assets/magento/magento-version-switching/magento-version-switching_medium.webp": "4d0d",
	"./assets/magento/magento-version-switching/magento-version-switching_medium@2x.webp": "4ca0",
	"./assets/magento/magento-version-switching/magento-version-switching_small.webp": "43da",
	"./assets/magento/magento-version-switching/magento-version-switching_small@2x.webp": "7a8d",
	"./assets/magento/project1.webp": "159f",
	"./assets/magento/project1@2x.webp": "84ba",
	"./assets/magento/project1_medium.webp": "0c8a",
	"./assets/magento/project1_medium@2x.webp": "f75e",
	"./assets/magento/project1_small.webp": "da60",
	"./assets/magento/project1_small@2x.webp": "1e90",
	"./assets/magento/project2.webp": "7589",
	"./assets/magento/project2@2x.webp": "78be",
	"./assets/magento/project2_medium.webp": "1d8c",
	"./assets/magento/project2_medium@2x.webp": "5e67",
	"./assets/magento/project2_small.webp": "af57",
	"./assets/magento/project2_small@2x.webp": "f0d9",
	"./assets/magento/project3.webp": "83e3",
	"./assets/magento/project3@2x.webp": "9ca2",
	"./assets/magento/project3_medium.webp": "641d",
	"./assets/magento/project3_medium@2x.webp": "f91b",
	"./assets/magento/project3_small.webp": "9467",
	"./assets/magento/project3_small@2x.webp": "8266",
	"./assets/outsourcing/outsorsing-banner-bg.webp": "cf92",
	"./assets/outsourcing/outsourcing-image-01.webp": "f808",
	"./assets/portfolio/al-based.webp": "5224",
	"./assets/portfolio/amx.webp": "6f2b",
	"./assets/portfolio/apple.webp": "1643",
	"./assets/portfolio/citrix.webp": "442c",
	"./assets/portfolio/classiccar.webp": "40bf",
	"./assets/portfolio/comparison.webp": "01a7",
	"./assets/portfolio/education.webp": "b928",
	"./assets/portfolio/gameit.webp": "6e40",
	"./assets/portfolio/games.webp": "9e39",
	"./assets/portfolio/google.webp": "9513",
	"./assets/portfolio/hopways.webp": "4c97",
	"./assets/portfolio/hygh.webp": "c8d5",
	"./assets/portfolio/parlient.webp": "31e5",
	"./assets/portfolio/pharmaceutical.webp": "8a09",
	"./assets/portfolio/quotation.webp": "0e05",
	"./assets/portfolio/razzo.webp": "5e52",
	"./assets/portfolio/resolute.webp": "d5b5",
	"./assets/portfolio/search-engine.webp": "1d39",
	"./assets/portfolio/seo-reporter.webp": "a68c",
	"./assets/portfolio/siemens.webp": "542a",
	"./assets/portfolio/spa-portfolio/head_product_images/amxmodules.webp": "af51",
	"./assets/portfolio/spa-portfolio/head_product_images/californiacrane.webp": "6c79",
	"./assets/portfolio/spa-portfolio/head_product_images/car-park-control-1.webp": "19e4",
	"./assets/portfolio/spa-portfolio/head_product_images/character-1.webp": "2e97",
	"./assets/portfolio/spa-portfolio/head_product_images/character-2.webp": "ef1b",
	"./assets/portfolio/spa-portfolio/head_product_images/character-3.webp": "f991",
	"./assets/portfolio/spa-portfolio/head_product_images/character-4.webp": "e6ec",
	"./assets/portfolio/spa-portfolio/head_product_images/character-5.webp": "c20d",
	"./assets/portfolio/spa-portfolio/head_product_images/citrix.webp": "3d98",
	"./assets/portfolio/spa-portfolio/head_product_images/classiccar.webp": "e346",
	"./assets/portfolio/spa-portfolio/head_product_images/education.webp": "4455",
	"./assets/portfolio/spa-portfolio/head_product_images/flicky-christmas-1.webp": "66c3",
	"./assets/portfolio/spa-portfolio/head_product_images/gameit.webp": "4e5f",
	"./assets/portfolio/spa-portfolio/head_product_images/games.webp": "b1b6",
	"./assets/portfolio/spa-portfolio/head_product_images/hopways.webp": "3f7c",
	"./assets/portfolio/spa-portfolio/head_product_images/hygh.webp": "082f",
	"./assets/portfolio/spa-portfolio/head_product_images/laspi.webp": "310a",
	"./assets/portfolio/spa-portfolio/head_product_images/laspi1.webp": "11b1",
	"./assets/portfolio/spa-portfolio/head_product_images/mystic-miners-1.webp": "225f",
	"./assets/portfolio/spa-portfolio/head_product_images/mystic-miners-2.webp": "52be",
	"./assets/portfolio/spa-portfolio/head_product_images/mystic-miners-3.webp": "cfd8",
	"./assets/portfolio/spa-portfolio/head_product_images/parliament.webp": "8c7b",
	"./assets/portfolio/spa-portfolio/head_product_images/pharmaceutical.webp": "eca4",
	"./assets/portfolio/spa-portfolio/head_product_images/phone-siemens.webp": "2bc8",
	"./assets/portfolio/spa-portfolio/head_product_images/ppc.webp": "8d00",
	"./assets/portfolio/spa-portfolio/head_product_images/price.webp": "d3c5",
	"./assets/portfolio/spa-portfolio/head_product_images/psycwave.webp": "6564",
	"./assets/portfolio/spa-portfolio/head_product_images/qj.webp": "676e",
	"./assets/portfolio/spa-portfolio/head_product_images/razzo.webp": "6270",
	"./assets/portfolio/spa-portfolio/head_product_images/resolute.webp": "a75a",
	"./assets/portfolio/spa-portfolio/head_product_images/resolute1.webp": "9183",
	"./assets/portfolio/spa-portfolio/head_product_images/rocketship.webp": "29d2",
	"./assets/portfolio/spa-portfolio/head_product_images/seekingsimple.webp": "ea7f",
	"./assets/portfolio/spa-portfolio/head_product_images/seekingsimple2.webp": "16e4",
	"./assets/portfolio/spa-portfolio/head_product_images/seo-reporter.webp": "1c05",
	"./assets/portfolio/spa-portfolio/head_product_images/shoutouts.webp": "b31a",
	"./assets/portfolio/spa-portfolio/head_product_images/siemens.webp": "6621",
	"./assets/portfolio/spa-portfolio/head_product_images/squishy-halloween-1.webp": "8cfc",
	"./assets/portfolio/spa-portfolio/head_product_images/sundashboard.webp": "a1e9",
	"./assets/portfolio/spa-portfolio/head_product_images/telemedecine.webp": "c3c5",
	"./assets/portfolio/spa-portfolio/head_product_images/telemedecine2.webp": "ca0e",
	"./assets/portfolio/spa-portfolio/head_product_images/touchpanel.webp": "6289",
	"./assets/portfolio/spa-portfolio/head_product_images/trafficgeneration.webp": "6e02",
	"./assets/portfolio/spa-portfolio/head_product_images/truebill.webp": "adf6",
	"./assets/portfolio/spa-portfolio/head_product_images/videocloud.webp": "1b08",
	"./assets/portfolio/spa-portfolio/head_product_images/vikings-1.webp": "798d",
	"./assets/portfolio/spa-portfolio/head_product_images/vikings-2.webp": "6319",
	"./assets/portfolio/spa-portfolio/head_product_images/vpn.webp": "3a52",
	"./assets/portfolio/spa-portfolio/new_icons/advisors.webp": "5cde",
	"./assets/portfolio/spa-portfolio/new_icons/amx_logo.webp": "6171",
	"./assets/portfolio/spa-portfolio/new_icons/angular.webp": "6dd2",
	"./assets/portfolio/spa-portfolio/new_icons/cisco_logo.webp": "353c",
	"./assets/portfolio/spa-portfolio/new_icons/citrix_logo.webp": "e3df",
	"./assets/portfolio/spa-portfolio/new_icons/coronalabs.webp": "576d",
	"./assets/portfolio/spa-portfolio/new_icons/js.webp": "d6cf",
	"./assets/portfolio/spa-portfolio/new_icons/js_logo.webp": "d795",
	"./assets/portfolio/spa-portfolio/new_icons/mandrill.webp": "a5ae",
	"./assets/portfolio/spa-portfolio/new_icons/php_logo.webp": "625c",
	"./assets/portfolio/spa-portfolio/new_icons/react.webp": "9f36",
	"./assets/portfolio/spa-portfolio/new_icons/redux.webp": "aec5",
	"./assets/portfolio/spa-portfolio/new_icons/siemens_logo.webp": "3443",
	"./assets/portfolio/spa-portfolio/new_icons/twilio.webp": "ab17",
	"./assets/portfolio/telemedicine.webp": "e5bf",
	"./assets/portfolio/telemedicine2.webp": "b3d3",
	"./assets/portfolio/telemedicine3.webp": "c8b7",
	"./assets/portfolio/touchpanel.webp": "3337",
	"./assets/portfolio/trafficgeneration.webp": "0744",
	"./assets/portfolio/truebill.webp": "9503",
	"./assets/portfolio/vpn.webp": "4821",
	"./assets/projects-image-01.webp": "5b18",
	"./assets/projects-image-02.webp": "a5ff",
	"./assets/projects-image-03.webp": "ca0d",
	"./assets/razzo/razzo-head-page-1.webp": "0c50",
	"./assets/razzo/razzo-head-page-2.webp": "9b60",
	"./assets/razzo/razzo-head-page-3.webp": "0a22",
	"./assets/razzo/razzo-head-page-4.webp": "8128",
	"./assets/razzo/razzo-head-page.webp": "19df",
	"./assets/razzo/razzo1.webp": "5194",
	"./assets/razzo/razzo2.webp": "9d93",
	"./assets/razzo/razzo3.webp": "8c91",
	"./assets/razzo/razzo4.webp": "2790",
	"./assets/razzo/razzo5.webp": "2f36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "703d";